export const capitalize = (str, includeDashes = false) => {
  if (!str) return '';
  const input = str
    .split(' ')
    .map((wrd) => wrd.substr(0, 1).toUpperCase() + wrd.substr(1).toLowerCase())
    .join(' ');

  return includeDashes
    ? input.replaceAll(/-([a-z])/gi, (match, p1) => '-' + p1.toUpperCase())
    : input;
};

export const formatDateOfBirth = (dob, addSpaces = false) => {
  const [year, month, day] = dob.split('-');
  return addSpaces ? `${day} / ${month} / ${year}` : `${day}/${month}/${year}`;
};

export const mask = (str) =>
  str?.length
    ? str
        .split('')
        .map(() => '*')
        .join('')
    : '';
